import { IncomingHttpHeaders } from 'http';

export default function getInternalHost(requestHeaders: IncomingHttpHeaders): string {
  const removeTrailingSlash = (str: string): string => str.replace(/\/+$/, '');
  const scheme = requestHeaders && requestHeaders['x-forwarded-proto'] ? requestHeaders['x-forwarded-proto'] : 'https';
  const host = requestHeaders?.host ? `${scheme}://${requestHeaders.host}` : process.env.NEXT_PUBLIC_HOST;
  return removeTrailingSlash(host || '');
}
